import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import LOOKUP from 'constants/lookup';
import * as types from 'constants/actionTypes';
import { selectPatientModel } from 'selectors/entitySelector';
import { formError } from 'actions/FormActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import TextInput from 'screens/components/basic/TextInput';
// Advanced Components
import DialogInputNew from 'screens/components/advanced/DialogInputNew';

const POSFirstNationIdCheckDialog = ({ patientId, firstName, lastName, open, onClose, onConfirm }) => {
    const { t } = useTranslation();
    const [showIdTypeError, setShowIdTypeError] = useState(false);
    const [showIdNumberError, setShowIdNumberError] = useState(false);
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const { POSPatientIdentificationNumber } = useSelector(state => state.form || {});


    useEffect(() => {
        if (patientId){
            dispatch({ type: types.PATIENT_FORM_LOAD, id: patientId, compName: "POSPatient" })
        }
    }, [patientId])

    const isOrderedSequence = (value) => {
        if (value.length < 3) return false;
        const chars = value.split('').map(Number);
    
        const ascending = chars.every((v, i, arr) => i === 0 || v === arr[i - 1] + 1);
        const descending = chars.every((v, i, arr) => i === 0 || v === arr[i - 1] - 1);
        
        return ascending || descending;
    };
      
    const isRepetitive = (value) => {
        if (value.length < 3) return false;
        return /^(\d)\1+$/.test(value);
    };

    const isValidInput = (value) => value && value.length > 2 && !isNaN(value) && !/\s/.test(value) && !isRepetitive(value) && !isOrderedSequence(value);


    const onSelectChange = (selectedValue) => setShowIdTypeError(selectedValue !== "IdentificationCard");
    
    const onIDChange = (e) => {
        setShowIdNumberError(!isValidInput(e.target.value));
        if (!isValidInput(e.target.value)){
            dispatch(formError(t('pos.fnCheckDialog.correntId'), 'POSPatientIdentificationNumber'))
        }
    }
    
    const saveIdNumber = () => {
        const patient = selectPatientModel(state, "POSPatient");

        if (patient.IdentificationType === "IdentificationCard" && isValidInput(patient.IdentificationNumber)){
            setShowIdTypeError(false);
            setShowIdNumberError(false);
            dispatch({ type: types.SAVE_PATIENT, patient, compName: "POSPatient" })
            onConfirm();
        }else if (patient.IdentificationType !== "IdentificationCard"){
            setShowIdTypeError(true);
        }else if (!isValidInput(patient.IdentificationNumber)){
            setShowIdNumberError(true);
        }
    }
    
    return (
        <DialogInputNew
            title={t('pos.fnCheckDialog.verifyFNId')}
            open={open}
            handleClose={onClose}
            actions={[
                <Button
                    key={2}
                    name="buttonConfirmFN"
                    label={t('common.confirm')}
                    className="btnNewBrandPOS"
                    onTouchTap={() => { saveIdNumber(); }} />]}
            contentStyle={{ width: '65%' }}>
            <p class="pa-1 text-center purpleText mb-0">
            <Trans i18nKey="pos.fnCheckDialog.verfiyFNCardBefore" 
                components={{ bold: <strong /> }} />
            </p>
            <ul>
            <li>{t('pos.fnCheckDialog.ensureTheNameMatches')}</li>
            <li>{t('pos.fnCheckDialog.checkTheCard')}</li>
            <li>{t('pos.fnCheckDialog.confirmegitimate')}</li>
            </ul>
            {!POSPatientIdentificationNumber ? <p class="pa-1 pb-0 text-center purpleText mb-0">{t('pos.fnCheckDialog.askProvideId')}</p> : <p class="pa-1 pb-0 text-center purpleText mb-0">{t('pos.fnCheckDialog.confirmIdWith')}</p>}
            <h6 class="pa-1 pb-0 purpleText m-0">{firstName} {lastName}</h6>
            <div className="row">
                <div className="col-md-4">
                    <SelectInput name="POSPatientIdentificationType"
                        label={LOOKUP.patient.idType.label}
                        floatingLabelText={LOOKUP.patient.idType.label}
                        hintText={LOOKUP.patient.idType.hintText}
                        options={LOOKUP.common.identificationTypes}
                        fullWidth={true}
                        defaultValue="IdentificationCard"
                        onChange={onSelectChange}
                    />
                </div>
                <div className="col-md-8">
                    <TextInput name="POSPatientIdentificationNumber"
                        label={LOOKUP.patient.idNumber.label}
                        floatingLabelText={LOOKUP.patient.idNumber.label}
                        hintText={LOOKUP.patient.idNumber.hintText}
                        fullWidth={true}
                        maxLength={50}
                        required
                        onChange={(e) => onIDChange(e)}
                        error={showIdNumberError ? `${t('pos.fnCheckDialog.correntId')}` : ``}
                    />
                </div>
            </div>
            <p class="pa-1 text-center purpleText mb-2">{t('pos.fnCheckDialog.complyWithRegulatory')}</p>
            {showIdTypeError  ? <p class="m-0 pa-1 error-text">{t('pos.fnCheckDialog.selectStatusId')}</p> : null}
            {showIdNumberError ? <p class="m-0 pa-1 error-text">{t('pos.fnCheckDialog.correntId')}</p> : null}
        </DialogInputNew>
    );
};

export default POSFirstNationIdCheckDialog;